/**
 * 会话缓存工具类
 */
export const SessionCache = {
  /**
   * 设置会话缓存
   * @param {string} key 键名
   * @param {any} value 值（支持对象、数组等）
   */
  set(key, value) {
    try {
      const data = typeof value === 'string' ? value : JSON.stringify(value);
      sessionStorage.setItem(key, data);
    } catch (error) {
      console.error('SessionCache.set 错误:', error);
    }
  },

  /**
   * 获取会话缓存
   * @param {string} key 键名
   * @param {any} defaultValue 默认值（可选）
   * @return {any} 存储的值或默认值
   */
  get(key, defaultValue = null) {
    try {
      const data = sessionStorage.getItem(key);
      if (data === null) return defaultValue;

      try {
        return JSON.parse(data);
      } catch {
        return data;
      }
    } catch (error) {
      console.error('SessionCache.get 错误:', error);
      return defaultValue;
    }
  },

  /**
   * 移除指定会话缓存
   * @param {string} key 键名
   */
  remove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error('SessionCache.remove 错误:', error);
    }
  },

  /**
   * 清空所有会话缓存
   */
  clear() {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error('SessionCache.clear 错误:', error);
    }
  },

  /**
   * 检查是否存在指定键
   * @param {string} key 键名
   * @return {boolean}
   */
  has(key) {
    try {
      return sessionStorage.getItem(key) !== null;
    } catch (error) {
      console.error('SessionCache.has 错误:', error);
      return false;
    }
  }
};